import React from "react";

export default function LinkList(props) {
  return (
    <section className="nsw-section related-links">
      <div className="sira-link-list white">
        <div className="nsw-link-list nsw-container">
          <h2>{props.heading}</h2>
          <ul>
            {props.links.map((group, groupInd) => (
              group.map((link, linkInd) => (
                <li key={`link_${groupInd}_${linkInd}`}>
                  <a 
                    href={link.url} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    title="Open in a new tab"
                  >
                    <span>{link.text}</span>
                    <span
                      className="material-icons nsw-material-icons"
                      focusable="false"
                      aria-hidden="true"
                      translate="no"
                    >
                      east
                    </span>
                  </a>
                </li>
              ))
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
